import * as BannerConstants from './BannerConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    bannerMessage: "",
    bannerMessageDisplay: "",
    marqueeBannerFlag: false,
    isBannerFetching: false,
    isBannerFetched: false,
    isBannerFetchFailed: false
}

export default function BannerReducer(state = initialState, action) {

    switch (action.type) {

        case BannerConstants.BANNER_LOAD_REQUEST:
            return assign({}, state, {
                isBannerFetching: true,
                isBannerFetchFailed: false
            });
        case BannerConstants.BANNER_LOAD_SUCCESS:
            return assign({}, state, {
                isBannerFetching: false,
                isBannerFetched: true,
                isBannerFetchFailed: false
            });
        case BannerConstants.BANNER_LOAD_FAILURE:
            return assign({}, state, {
                isBannerFetching: false,
                isBannerFetchFailed: true
            });

        case BannerConstants.SET_BANNER_MESSAGE:
            return assign({}, state, {
                bannerMessage: action.newState.bannerMessage,
            });
            break;
        case BannerConstants.BANNER_MESSAGE_DISPLAY:
            return assign({}, state, {
                bannerMessageDisplay: action.newState.bannerMessageDisplay
            });
            break;
        case BannerConstants.MARQUEE_BANNER_FLAG:
            return assign({}, state, {
                marqueeBannerFlag: action.newState.marqueeBannerFlag
            });
            break;

        default:
            return state;

    }

}